import styled from 'styled-components';
import { ContainedFormReactSelect } from '../../../Form/FinalForm/Contained/ContainedFormReactSelect';
import LockIcon from 'components/Icons/lock.svg';
import UnlockIcon from 'components/Icons/unlock.svg';
import { useField } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { toggleIsSellerLocked, useIsSellerLocked } from 'services/sellerLock/sellerLockSlice';
import React from 'react';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 12px;
  div:first-child {
    flex: 1 1 80%;
  }
`;

const onMenuOpen = () => {
  document.body.style.touchAction = 'none';
  document.body.style.overflow = 'hidden';
};

const onMenuClose = () => {
  document.body.style.touchAction = '';
  document.body.style.overflow = '';
};

const LockWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
`;

const SellerLockComponent = () => {
  const {
    input: { value: isLocked, onChange: setLock }
  } = useField('is_locked');

  const {
    input: { value: sellerId }
  } = useField('seller_id');

  const dispatch = useDispatch();

  const isSellerLocked = useIsSellerLocked();

  const toggle = () => {
    setLock(!isLocked);
    dispatch(toggleIsSellerLocked(sellerId));
  };

  return <LockWrapper onClick={toggle}>{isSellerLocked ? <LockIcon /> : <UnlockIcon />}</LockWrapper>;
};

type Props = {
  userOptions: Array<{ value: number; label: string }>
  prefix?: string
}

export const SellerField: React.FC<Props> = ({ userOptions }) => {
  const isSellerLocked = useIsSellerLocked();

  const afterSelect = (data: { value: number }) => {
    if (!isSellerLocked) return;
    localStorage.setItem('locked_seller', data.value.toString());
  };

  return (
    <Wrapper>
      <ContainedFormReactSelect
        onMenuClose={onMenuClose}
        onMenuOpen={onMenuOpen}
        menuPosition="absolute"
        afterSelect={afterSelect}
        label="Seller"
        name="seller_id"
        options={userOptions}
      />
      <SellerLockComponent />
    </Wrapper>
  );
};
